// Document
export enum RouteMode {
  LAST_AND_EMPTY = 0,
  ONLY_LAST = 1
}
